import { useCallback } from 'react';

import { isEqual } from 'lodash';

import { TState } from '../schedule';

export function useNormalizeEDs(state: TState) {
    const normalizeEDs = useCallback(() => {
        const dayOffs: number[] = [];
        const excDays: any[] = [];
        const scheduleDays: any[] = [];

        const defDay = {
            start_time: state.schedule.start_time,
            end_time: state.schedule.end_time,
            breaks: state.schedule.breaks,
        };

        for (let i = 0; i < state.eds.length; i++) {
            const ed = state.eds[i];

            if (ed.is_day_off) {
                dayOffs.push(+ed.day);
            } else {
                const currentDay = {
                    start_time: ed.start_time,
                    end_time: ed.end_time,
                    breaks: ed.breaks,
                };

                if (isEqual(defDay, currentDay)) {
                    scheduleDays.push({
                        day: ed.day,
                        start_time: ed.start_time,
                        end_time: ed.end_time,
                    });
                } else {
                    excDays.push(ed);
                }
            }
        }

        state.schedule.schedule_days = scheduleDays;
        state.schedule.day_offs = dayOffs;
        state.schedule.exception_days = excDays;
    }, [state]);

    return { normalizeEDs };
}
